import { Box, Grid } from "@mui/material";
import React, { useState } from "react";

import AccountCircle from "@mui/icons-material/AccountCircle";
import AppBar from "@mui/material/AppBar";
import Divider from '@mui/material/Divider';
import HeaderContent from "./HeaderContent";
import IconButton from "@mui/material/IconButton";
import { Link } from "react-router-dom";
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import LogoutIcon from "@mui/icons-material/Logout";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MenuList from '@mui/material/MenuList';
import MoreIcon from "@mui/icons-material/MoreVert";
import PersonIcon from '@mui/icons-material/Person';
import ProfilePhoto from "../components/ProfilePhoto"
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import nativeCodersLogo from "../images/HeaderFrame.png";
import { useAuth } from "../providers/AuthProvider"
import { useProfile } from "../providers/ProfileProvider";

const Header = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const auth = useAuth();
  const profile = useProfile();

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      id={menuId}
      keepMounted
      open={isMenuOpen}
      onClose={handleMenuClose}
      slotProps={{
        paper: {
          sx: {
            mt: -1,
            width: "250px"
          },
        },
      }}
    >
      <MenuList>
        <MenuItem
          disableRipple
          sx={{
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          {profile && (
            <Grid item>
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "16px",
                  lineHeight: "24px",
                  color: "#000000DE",
                  fontFamily: "Roboto ,sans-serif",
                  fontStyle: "normal",
                  letterSpacing: "0.15px"
                }}
              >
                {profile.firstname} {profile.lastname}
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Roboto, sans-serif",
                  color: "#00000099",
                  fontWeight: 300,
                  fontSize: "14px",
                  lineHeight: "24px",
                }}
              >
                {profile.email}
              </Typography>
            </Grid>
          )}
          <Divider />

        </MenuItem>
        <Divider />

        <MenuItem component={Link}
          to="/onboarding">
          <ListItemIcon>
            <PersonIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="Profile"
            primaryTypographyProps={{
              sx: {
                fontFamily: "Roboto, sans-serif",
                fontWeight: 500,
                fontSize: "14px",
                lineHeight: "24px",
              },
            }}
          />
        </MenuItem>
      

        <MenuItem onClick={auth.logout}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="Sign Out"
            primaryTypographyProps={{
              sx: {
                fontFamily: "Roboto, sans-serif",
                fontWeight: 500,
                fontSize: "14px",
                lineHeight: "24px",
              },
            }}
          />
        </MenuItem>
      </MenuList>
    </Menu >
  );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );


  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" sx={{ backgroundColor: "#463C3B" }}>
        <Toolbar>
          {/* Logo on the left */}
          <Box sx={{ mr: 2, pl: 3 }}>
            <Link to="/" style={{ textDecoration: 'none' }}>
              <img 
                src={nativeCodersLogo} 
                alt="Native Coders Logo" 
                style={{ 
                  height: '40px', 
                  width: 'auto',
                  display: 'block',
                  cursor: 'pointer'
                }} 
              />
            </Link>
          </Box>

          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center',
            flexGrow: 1 
          }}>
            <HeaderContent />
          </Box>

          {/* Profile section on the right */}
          <Box sx={{ display: { xs: "none", md: "flex" } }}>
            <IconButton
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
              disableRipple
              disableFocusRipple
              sx={{ mb: 0 }}
            >
              <ProfilePhoto
                firstName={profile?.firstname ?? "O"}
                lastName={profile?.lastname ?? "P"}
              />
            </IconButton>
            <Grid
              container
              alignItems="center"
              justifyContent="center"
              direction="row"
              onClick={handleProfileMenuOpen}
              sx={{ ml: 1 }}
            >
            </Grid>
          </Box>
          <Box sx={{ display: { xs: "flex", md: "none" } }}>
            <IconButton
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </Box>
  );
};

export default Header;